/**
 * Forces a hard reload by adding a cache-busting timestamp to the current URL.
 * This ensures the browser fetches fresh resources instead of using cached content.
 */
export const hardReload = () => {
    const url = new URL(window.location.href);
    // Append timestamp to bypass cache
    url.searchParams.set('t', Date.now().toString());
    window.location.href = url.href;
};
